import React, { ReactElement } from "react";
import classnames from "classnames";
import { NavFooter } from "components/Footer";
import { NavHeader } from "components/Header";
import { headerPromotion } from "config";

const TopHeaderLayout: React.FC<{ page: ReactElement }> = ({ page }) => {
  const pageWrapperClasses = classnames("page-wrapper", {
    "with-promo": headerPromotion?.shouldShow,
  });

  return (
    <>
      <main className={pageWrapperClasses}>
        <NavHeader />
        {page}
      </main>
      <NavFooter />
    </>
  );
};

export default TopHeaderLayout;
